import {gql} from "@apollo/client";

export const BOT_UNLINK_USER_MUTATION = gql`
  mutation BotUnlinkUser($userId: ID!, $type: BotLinkType!) {
      botUnlinkUser(userId: $userId, type: $type)
  }
`
